import { OperationStatus } from "../models/Transactions";

export const transactionDirection = (dir:any, classname:string = '') => {
    if (dir.direction === 'OUT') return classname + ' negative'
    if (dir.direction === 'IN') return classname + ' positive'
    if (dir.direction !== 'IN' && dir.direction !== 'OUT') return classname + ' same'
    return classname;
} 

export const checkDirectionClass = (entry:any, classname:string = '', inverse? : boolean) => {

    let value;
    if (entry.value) value = entry.value;
    if (entry.d_value) value = entry.d_value;

    if (!value) return 'not-defined';
    const val = Number(value);
    if (val > 0) {
        if (inverse) return classname + " negative";
        return classname + " positive";
    }
    else if (val < 0) {
        if (inverse) return classname + " positive";
        return classname + " negative";
    }
    else return classname;
}

export const transactionType = (type:string) => {
    if (!type) return '';
    if (type === 'all') return 'Transacao';
    if (type === 'deposits') return 'Deposito';
    if (type === 'invoices') return 'Saque'; 
    if (type === 'purchases') return 'Compra'; 
}

export const TransactionStatus = (entry:any) => {

    const { status } = entry;

    if (
        status === OperationStatus.APPROVED || 
        status === OperationStatus.CONFIRMED || 
        status === OperationStatus.COMPLETED 
    ) {
        return "status success";
    } else if (
        status === OperationStatus.PENDING || 
        status === OperationStatus.CONFIRMING ||
        status === OperationStatus.WAITING
    ) {
        return "status pending";
    } else if (
        status === OperationStatus.CANCELED || 
        status === OperationStatus.FAILED ||
        status === OperationStatus.DENIED
    ) {
        return "status error";
    } else if (
        status === OperationStatus.CREATED 
    ) {
        return "status info";
    }

    return "status unknown";
}